import React from 'react';
import { Link } from 'react-router-dom';

/**
 * BreadcrumbMarker - Luxury breadcrumb navigation component
 * @param {string} parentLabel - Label for the parent section (e.g., "SERVICES")
 * @param {string} parentHref - Link to parent page (e.g., "/services")
 * @param {string} currentLabel - Label for the current page (e.g., "VIRTUAL TWILIGHT")
 * @param {string} background - Background color class (default: "bg-[#FAF9F6]")
 */
const BreadcrumbMarker = ({ 
  parentLabel, 
  parentHref, 
  currentLabel,
  background = "bg-[#FAF9F6]"
}) => {
  return (
    <section className={`${background} border-b border-gray-100`}>
      <div className="max-w-6xl mx-auto px-6 py-5 md:py-6">
        <div className="flex items-center gap-3">
          <Link 
            to={parentHref} 
            className="text-[11px] font-medium tracking-[0.2em] uppercase text-[#F5C056] hover:text-[#F5C056]/80 transition-colors"
          >
            {parentLabel}
          </Link>
          <span className="text-[#050816]/30 text-xs">/</span>
          <span className="text-[11px] font-semibold tracking-[0.2em] uppercase text-[#050816]">
            {currentLabel}
          </span>
        </div>
        {/* Subtle gold accent line */}
        <div className="w-12 h-[1.5px] bg-[#F5C056]/40 mt-4"></div>
      </div>
    </section>
  );
};

export default BreadcrumbMarker;
